<template>
  <div>
    <div class="page-header clear-filter main-background-filter">
      <parallax
        class="page-header-image"
        style="background-image: url('img/map.png')"
      >
      </parallax>
      <div class="main-logo-top-left">
        <a href="https://www.instagram.com/serendipiagames">
          <img
            class="col-4 col-md-4 col-sm-4 col-lg-2 col-xl-2"
            src="img/SerendipiaLogoHorizontal.png"
            alt=""
          />
        </a>
      </div>
      <div class="container">
        <div class="content-center">
          <div class="row">
            <div class="col-md-4 ml-auto mr-auto text-left col-10 text-md-right ">
            <img
            class="n-logo"
            src="https://serendipiagames.com/img/presskit/logos/teios-main-logo.png"
            alt="" />
              <h4>ACTION ADVENTURE GAME IN DEVELOPMENT</h4>              
              <h5 class="d-md-block">
                Embark on a thrilling adventure through a vibrant world teeming with challenges and mysteries. Traverse diverse landscapes, solve intricate puzzles, and engage in epic battles as you unravel the secrets hidden within the land.
              </h5>
            </div>
            <div class="col-md-8 ml-auto mr-auto text-right col-10 text-md-left text-left">
              <div class="section-story-overview align-center">
                <iframe
                  class="iframe-trailer"
                  src="https://www.youtube.com/embed/CpHJR2DNm1c?autoplay=1"
                  width="960"
                  height="540"
                  allow="autoplay"
                ></iframe>
              </div>
              <a
                class="btn btn-info btn-sm"
                href="https://store.steampowered.com/app/3506070/Teios_Journey/"
                target="_blank"
              >
                Wishlist on
                <img
                  src="https://store.fastly.steamstatic.com/public/shared/images/header/logo_steam.svg?t=962016"
                  alt="Game Image 1"
                  class="game-logo"
                  style="width: 30%"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main main-container">      
       <div class="container">
        
        <div class="section-presskit-overview row">
          <h3>Screenshots</h3>
          <div class="text-left color-black row">
            <div class="col-12">
              <!--img src="img/presskit/screenshots/teios_journey_1.png" alt="Game Image 1" class="game-image" /-->
              <img src="img/presskit/screenshots/teios_journey_2.png" alt="Game Image 2" class="game-image"/>
              <img src="img/presskit/screenshots/teios_journey_3.png" alt="Game Image 2" class="game-image"/>
              <img src="img/presskit/screenshots/teios_journey_4.png" alt="Game Image 2" class="game-image"/>
              <!--img src="img/presskit/screenshots/teios_journey_5.png" alt="Game Image 2" class="game-image"/-->
              <img src="img/presskit/screenshots/teios_journey_6.png" alt="Game Image 2" class="game-image"/>
              <img src="img/presskit/screenshots/teios_journey_7.png" alt="Game Image 2" class="game-image"/>
              <img src="img/presskit/screenshots/teios_journey_8.png" alt="Game Image 2" class="game-image"/>
              <img src="img/presskit/screenshots/teios_journey_9.png" alt="Game Image 1" class="game-image" />
              <!--img src="img/presskit/screenshots/teios_journey_10.png" alt="Game Image 1" class="game-image" /-->
              <img src="img/presskit/screenshots/teios_journey_11.png" alt="Game Image 1" class="game-image" />
              <img src="img/presskit/screenshots/teios_journey_12.png" alt="Game Image 1" class="game-image" />
              <img src="img/presskit/screenshots/teios_journey_13.png" alt="Game Image 1" class="game-image" />              
            </div>
          </div>
        </div>

        <div class="presskit-buttons text-center">
            <h3> If you'd like to write about Teios Journey, we've a <br/>Press Kit full of videos, facts and images. </h3>
            <p>For any additional press enquiries, please contact: <a href="mailto:info@serendipiagames.com" >info@serendipiagames.com</a> </p>
            <div class="col-md-8 ml-auto mr-auto col-10 ">
              <a class="btn btn-info btn-lg"  href="/#/presskit" >    PRESSKIT    </a>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Parallax } from "@/components";

export default {
  name: "index",
  bodyClass: "index-page",
  components: {
    Parallax,
  },
};
</script>
<style scoped>
.iframe-trailer {
  height: auto;
  width: 100%;
  aspect-ratio: 16 / 9;
  border: none;
  margin: 0;
}

.main-background-filter {
  background-image: radial-gradient(rgb(0 0 0), rgb(0 0 0 / 46%), rgba(0, 0, 0, 0))
}

.factsheet-list {
  margin: 0;
  padding: 0;
}
.fact-item {
  display: flex;
  margin-bottom: 8px;
}
.fact-item dt {
  min-width: 130px;
  font-weight: bold;
  margin-right: 10px;
}
.fact-item dd {
  margin: 0;
}

.game-gif {
  max-height: 300px;
  text-align: center !important; 
}
.game-logo {
  max-height: 200px;
  text-align: center !important; 
}

.teios-header { 
  background-position-y: center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
}

.presskit-header {
  padding-top: 40px !important;
}

.presskit-buttons {
  padding: 20px 0px 40px 0px;
}

.section-presskit-overview {
  padding: 30px 0;
}

.game-image {
    max-width: 50%;
    height: auto;
    padding: 10px;
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    border-radius: 20px;
}


.iframe-container {
    display: flex;
    justify-content: center;
}
    
.iframe-youtube {
    aspect-ratio: 16 / 9;
    width: 100% !important;
    height: auto;
}

.main-container{
  background-color: #1e1e1e;
}

.main-container{
  background-color: #1e1e1e;
  color: #f2ebeb !important;
}

</style>
